import { Cover } from '@app/shared/models/cover';
import { TransferFile } from '@app/shared/models/transferFile';
import { createAction, props } from '@ngrx/store';
import { GetTransferPreviewOutput } from '@smash-sdk/transfer/ejs/01-2024';
import { SDKError } from '@smash-sdk/core';
import { GetUsageOutput } from '@smash-sdk/gnitekram';

// Viewer layout
export const DisplayModalPreview = createAction(
  '[Viewer] Display Modal Preview'
);

export const CloseModalPreview = createAction(
  '[Viewer] Hide Modal Preview'
);

//Cover
export const LoadCover = createAction(
  '[Viewer] Load Cover',
  props<{ transferId: string }>()
);

export const LoadCoverSuccess = createAction(
  '[Viewer] Load Cover Success',
  props<{ cover: Cover }>()
);

export const LoadCoverFailure = createAction(
  '[Viewer] Load Cover Failure',
  props<{ error: string }>()
)

//Preview
export const LoadPreview = createAction(
  '[Viewer] Load Preview',
  props<{ transferId: string, password?: string, accessTracking?: string }>()
);

export const LoadPreviewSuccess = createAction(
  '[Viewer] Load Preview Success',
  props<{ preview: GetTransferPreviewOutput }>()
);

export const LoadPreviewFailure = createAction(
  '[Viewer] Load Preview Failure',
  props<{ error: any }>()
);

export const LockPreview = createAction(
  '[Viewer] Lock Preview',
  props<{ passwordRequired: boolean, accessTrackingRequired: boolean }>()
);

export const SelectFileToPreview = createAction(
  '[Viewer] Select File To Preview',
  props<{ file: TransferFile, offsetY: number }>()
);

export const AddFileToDownloadList = createAction(
  '[Viewer] Add File To Download List',
  props<{ file: TransferFile }>()
);

export const RemoveFileFromDownloadList = createAction(
  '[Viewer] Remove File To Download List',
  props<{ file: TransferFile }>()
);

// Menu display
export const ToggleMenu = createAction(
  '[Viewer] Toggle Menu',
  props<{ menuDisplayed: boolean }>()
);

// Unlock preview
export const UnlockPreview = createAction(
  '[Viewer] Unlock Preview',
  props<{ password: string }>()
);

export const UnlockPreviewSuccess = createAction(
  '[Viewer] Unlock Preview Success',
  props<{ preview: GetTransferPreviewOutput }>()
);

export const UnlockPreviewFailure = createAction(
  '[Viewer] Unlock Preview Failure',
  props<{ errorType: 'WRONG_PASSWORD' | 'EMAIL_INVALID' }>()
);

// Transfer promotion
export const LoadPromotion = createAction(
  '[Viewer] Load Promotion',
  props<{ promotionUrl: string }>()
);

export const LoadPromotionSuccess = createAction(
  '[Viewer] Load Promotion Success',
  props<{ promotion: any }>()
);

export const LoadPromotionFailure = createAction(
  '[Viewer] Load Promotion Failure',
  props<{ error: any }>()
);

export const ResetSelectedFiles = createAction(
  '[Viewer] Reset Selected Files',
);

// Files 
export const LoadFiles = createAction(
  '[Viewer] Load Files',
);

export const LoadFilesSuccess = createAction(
  '[Viewer] Load Files Success',
  props<{ files: TransferFile[], next: string }>()
);

export const LoadFilesFailure = createAction(
  '[Viewer] Load Files Failure',
  props<{ error: any }>()
);

export const LoadMoreFiles = createAction(
  '[Viewer] Load More Files',
);

export const LoadMoreFilesSuccess = createAction(
  '[Viewer] Load More Files success',
  props<{ files: TransferFile[], next: string }>()
);

export const LoadMoreFilesFailure = createAction(
  '[Viewer] Load More Files failure',
  props<{ error: any }>()
);

export const RefreshFileAndAssociatedFiles = createAction(
  '[Viewer] Refresh Files And Associated Files',
  props<{ file: TransferFile }>()
);

export const RefreshFileAndAssociatedFilesSuccess = createAction(
  '[Viewer] Refresh Files And Associated Files success',
  props<{ files: TransferFile[] }>()
);

export const RefreshFileAndAssociatedFilesFailure = createAction(
  '[Viewer] Refresh Files And Associated Files failure',
  props<{ error: any }>()
);

export const RequestDownloadUrls = createAction(
  '[Viewer] Request Download Urls',
  props<{ file?: TransferFile }>()
);

export const RequestDownloadUrlsSuccess = createAction(
  '[Viewer] Request Download Urls Success',
  props<{ urls: string[] }>()
);

export const RequestDownloadUrlsFailure = createAction(
  '[Viewer] Request Download Urls Failure',
  props<{ error: any }>()
);

// Hide/Display Download Section
export const DisplayDownloadSection = createAction(
  '[Viewer] Display Download Section',
);

export const HideDownloadSection = createAction(
  '[Viewer] Hide Download Section',
);

export const LoadTransferInternal = createAction(
  '[Viewer] Load Transfer Internal',
  props<{ transferId: string, region: string }>()
)

export const LoadTransferInternalSuccess = createAction(
  '[Viewer] Load Transfer Internal Success'
)


export const LoadTransferMetas = createAction(
  '[Viewer] Load Transfer Metas'
)

export const LoadTransferMetasSuccess = createAction(
  '[Viewer] Load Transfer Metas Success',
  props<{ transfer: any }>()
)

export const LoadTransferMetasFailure = createAction(
  '[Viewer] Load Transfer Metas Failure',
  props<{ error: SDKError['code'] }>()
);

// CheckFirstTimeReceiver
export const CheckFirstTimeReceiver = createAction(
  '[Viewer] Check First Time Receiver',
  props<{ username: string, transferId: string }>()
);

export const CheckFirstTimeReceiverSuccess = createAction(
  '[Viewer] Check First Time Receiver Success',
  props<{ usage: GetUsageOutput['usage'] }>()
);

export const CheckFirstTimeReceiverFailure = createAction(
  '[Viewer] Check First Time Receiver Failure',
  props<{ error: any }>()
);
